export default __webpack_public_path__ + "static/media/pepper_selfie.3f08d9f0.svg";